<script>
  import DrugSearch from '../DrugSearch/DrugSearch.svelte';
  
  let { headingText = $bindable(), headingLevel = 'h1', drugSearch, dataTestId = 'search-promo', lang } = $props();

  // remove html tags from heading content
  headingText = headingText && headingText.content ? headingText.content.replace(/<\/?[^>]+(>|$)/g, '') : undefined;
</script>

<div class="flex justify-center bg-blue-very-light" data-testid={dataTestId}>
  <div class="max-w-lg md:max-w-screen-sm xl:w-1/2 md:items-start py-6 px-4 md:py-12 lg:py-20">
    {#if headingText}
      {#if headingLevel === 'h1'}
        <h1
          class="mb-4 md:mb-6 text-center leading-tight text-blue-navy text-2xl md:text-3xl lg:text-4xl"
          data-testid="search-promo-heading"
        >
          {@html headingText}
        </h1>
      {:else if headingLevel === 'h2'}
        <h2
          class="mb-4 md:mb-6 text-center leading-tight text-blue-navy text-2xl md:text-3xl lg:text-4xl"
          data-testid="search-promo-heading"
        >
          {@html headingText}
        </h2>
      {:else if headingLevel === 'h3'}
        <h3
          class="mb-4 md:mb-6 text-center leading-tight text-blue-navy text-2xl md:text-3xl lg:text-4xl"
          data-testid="search-promo-heading"
        >
          {@html headingText}
        </h3>
      {:else}
        <h4
          class="mb-4 md:mb-6 text-center leading-tight text-blue-navy text-2xl md:text-3xl lg:text-4xl"
          data-testid="search-promo-heading"
        >
          {@html headingText}
        </h4>
      {/if}
    {/if}
    <DrugSearch {...drugSearch} {lang} />
  </div>
</div>
